/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.validation.required\":[\"Velg et alternativ.\"],\"radio-group.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map